/**
 * Inline header height calculation (matches utilities.js theme patterns).
 * Runs synchronously after #header-group is parsed.
 */
(function setHeaderHeighCustomProperties() {
  var header = document.querySelector('header-component');
  var headerGroup = document.querySelector('#header-group');
  var hasHeaderSection = headerGroup && headerGroup.querySelector('.header-section');

  if (!header || !headerGroup) return;

  var headerHeight = header.offsetHeight;

  var headerGroupHeight = 0;
  var children = headerGroup.children;
  for (var i = 0; i < children.length; i++) {
    var element = children[i];
    if (element === header || !(element instanceof HTMLElement)) continue;
    headerGroupHeight += element.offsetHeight;
  }

  if (header.hasAttribute('transparent') && header.parentElement && header.parentElement.nextElementSibling) {
    headerGroupHeight += headerHeight;
  }

  document.body.style.setProperty('--header-height', headerHeight + 'px');
  document.body.style.setProperty('--header-group-height', headerGroupHeight + 'px');

  if (!hasHeaderSection || !header.hasAttribute('transparent')) {
    document.body.style.setProperty('--transparent-header-offset-boolean', '0');
    return;
  }

  var hasImmediateSection = hasHeaderSection.nextElementSibling
    ? hasHeaderSection.nextElementSibling.classList.contains('shopify-section')
    : false;

  var shouldApplyOffset = !hasImmediateSection ? '1' : '0';
  document.body.style.setProperty('--transparent-header-offset-boolean', shouldApplyOffset);
})();
